import React from 'react';
import './buttonPrimary.scss';

const ButtonPrimary = (props) => {
  const handleBtnClick = () => {
    props.deepLinkRedirect();
  };

  return (
        <button
          type='button'
          className={`button-primary ${props.customClass}`}
          onClick={handleBtnClick}
        >
          {props.title}
        </button>
  );
};

export default ButtonPrimary;
